<script setup lang="ts">
import senpaiIcon from '@/assets/images/story/Icon_senpai.webp'

interface Props {
  workTitle: string
  mpCost: number
  mpEnergy?: number
  mpCapacity?: number
}

const props = withDefaults(defineProps<Props>(), { mpEnergy: 0, mpCapacity: 0 })
const dialog = defineModel<boolean>()
const emit = defineEmits<{
  submit: []
}>()

const hasSufficientMp = computed(() => props.mpEnergy >= props.mpCost)

// EventDialog (event_master) と同じ MDC + speaker icon パターンで描画する。
// 文体・記法 (`**bold**` / `*italic*` / 💧 / 単一空行で段落分け) も同 dialog 群に合わせる。
const text = computed(() => {
  const lines = [
    `**「${props.workTitle}」** のクリスタルか。  `,
    '<br/>',
    `デコードすれば、元の魔導書を羽根筆のゆりかごで読めるようになるぜ。リミックスの素材としても使えるんだ。**${props.mpCost}** MPが必要だ。  `,
    '<br/>',
    `💧 魔導エネルギーの残量： *${props.mpEnergy}* / ${props.mpCapacity}  `,
    '<br/>',
  ]
  if (!hasSufficientMp.value) {
    lines.push('', '**MPが足りないみたいだ。**')
  }
  return lines.join('\n')
})

const onSubmit = () => emit('submit')
</script>

<template>
  <Dialog
    v-model="dialog"
    title="クリスタルをデコードする"
    :submit-button="{
      title: 'デコード',
      sound: 'submit',
      effect: 'glow',
      disabled: !hasSufficientMp,
    }"
    :cancel-button="{ title: hasSufficientMp ? 'やめる' : '閉じる' }"
    @submit="onSubmit"
    @cancel="dialog = false"
  >
    <v-row>
      <v-col cols="auto">
        <v-img
          :src="senpaiIcon"
          cover
          class="speaker-icon"
        />
      </v-col>
      <v-col>
        <MDC :value="text" />
      </v-col>
    </v-row>
  </Dialog>
</template>

<style scoped>
.speaker-icon {
  width: max(64px, calc(12 * var(--u)));
  height: max(64px, calc(12 * var(--u)));
}
</style>
